export type WorkflowDurationUnit = 'minutes' | 'hours' | 'days';

export const workflowDurationUnits = {
  minutes: { label: '분', multiplier: 1 },
  hours: { label: '시간', multiplier: 60 },
  days: { label: '일', multiplier: 1440 },
} as const;

export function preferredWorkflowDurationUnit(minutes: string): WorkflowDurationUnit {
  const value = Number(minutes);
  if (!minutes.trim() || !Number.isFinite(value) || value <= 0) return 'hours';
  if (value % 1440 === 0) return 'days';
  if (value % 60 === 0) return 'hours';
  return 'minutes';
}

export function workflowDurationMinutes(value: string, unit: WorkflowDurationUnit): string {
  if (!value.trim()) return '';
  const result = Number(value) * workflowDurationUnits[unit].multiplier;
  return String(Math.round(result * 1e8) / 1e8);
}

export function workflowDurationLabel(minutes: string | number | null | undefined): string {
  if (minutes === undefined || minutes === null || String(minutes).trim() === '') return '설정 안 함';
  const value = Number(minutes);
  if (!Number.isInteger(value) || value <= 0) return '시간 확인 필요';
  const days = Math.floor(value / 1440);
  const hours = Math.floor((value % 1440) / 60);
  const remainder = value % 60;
  return [days ? `${days}일` : '', hours ? `${hours}시간` : '', remainder ? `${remainder}분` : ''].filter(Boolean).join(' ');
}
